import http from '../../services/httpService';
import apiEndpoint from '../../constants/config.json'

//create method create_new_check_out_order

export function fetchVenue(){
    const fullApiEndpoint = apiEndpoint.apiEndpoint + "/venueManagement/api/fetch_venue/";
    return http.get(fullApiEndpoint);
}